import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {UserLink} from 'src/components/links';

import {
    userSearchResultAuditDataSelector,
    userSearchResultAuditResultSelector,
} from '../../slices/user-search-result-audit.slice';

type Props = {
    userId: number,
    place: string,
};

export const CreatorCell = ({userId, place}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultAuditDataSelector);
    const result = useSelector(userSearchResultAuditResultSelector);

    const creatorInfo = useMemo(
        () => result?.data[userId]?.created.modifierInfo,
        [result, userId],
    );

    if (isLoading || loadingError || !creatorInfo) {
        return null;
    }

    return (
        <UserLink
            userId={creatorInfo.userId}
            caption={[
                creatorInfo.userFirstName,
                creatorInfo.userLastName,
            ].filter(Boolean).join(' ') || creatorInfo.userId?.toString()}
            place={place}
        />
    );
};
